export const comfamaDomains = [
   '.comfama.com/',
   '.viajescomfama.com/',
   '.comfamapro.com/',
   '.latiquetera.com/'
];
